import { Component, OnInit, Input, Output, EventEmitter, inject, ViewChild, ElementRef, ViewChildren, QueryList, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule } from '@angular/common';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { PlanificacionService } from '../../../services/planificacion.service';
import { OrganizacionesComponent } from "./organizaciones/organizaciones.component";
import { OrganizacionSeleccionComponent } from './organizacion-seleccion/organizacion-seleccion.component';
import { ModalComponent } from "../../modal/modal.component";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-programacion',
  standalone: true,
  imports: [CommonModule, OrganizacionSeleccionComponent, ModalComponent, FormsModule], //NgxMaskDirective
  templateUrl: './programacion.component.html',
  styleUrl: './programacion.component.css',
  providers: [provideNgxMask()],
})
export class ProgramacionComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @ViewChildren('cupo') inputCupo!: QueryList<ElementRef<HTMLInputElement>>; // Ya lo tienes, pero asegúrate
  @ViewChild("mdlOrganizacion",{static: true}) content!: ElementRef;
  @Input() year?: number;
  @Input() user?: any;
  @Output() subVolver = new EventEmitter;


  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  mensaje_calulo!: string;
  color!: string;


  private modalService = inject(NgbModal);
  private servicios = inject(PlanificacionService);

  isOrganizacion: boolean = false;
  isOrgSeleccion: boolean = false;
  id_alternativa?: number;
  id_ambito: string = '';
  id_centro: number = 0;
  nom_ambito?: string;
  resultado: any = []
  alternativa: any = []
  organizaciones: any = []
  idMetaRegional!: string;
  nomOrganizacion!: string;
  calculo_cupo: number = 0; // Variable para almacenar la suma de los cupos
  estadoCheckboxes: { [key: number]: boolean } = {}; // Nuevo objeto para rastrear el estado de los checkboxes

  filtroOrganizaciones: any[] = []; // Array para almacenar los resultados filtrados
  nombreBusqueda: string = ''; // Variable para el input de búsqueda

  organizacionesSeleccionadas: number[] = []; // Array para almacenar los IDs seleccionados

  cuposOrganizaciones: { [key: number]: string } = {};

  indiceADesactivar: number | null = null; // Inicialmente ninguno deshabilitado

  ngOnInit(): void {
    console.log(this.user)
    this.listarAmbitos(this.user.id_institucional, this.year!);
  }


  ngAfterViewChecked(): void {
    /*
    this.restaurarCuposDespuesFiltrar();
    this.actualizarSumaCupos(); // Calcular la suma en cada revisión de la vista
    if(this.calculo_cupo > 50){
      this.mensaje_calulo = 'la suma del cupo no puede ser superior a 50'
      this.color = 'text-danger'
    }
    else{
      this.mensaje_calulo = 'Suma de Cupos'
      this.color = 'text-dark'
    }
    */
  }

  actualizarSumaCupos() {
    this.calculo_cupo = 0;
    this.inputCupo.forEach((inputRef, index) => {
      const inputValue = inputRef.nativeElement.value;
      const numero = parseFloat(inputValue);
      if (!isNaN(numero)) {
        this.calculo_cupo += numero;
      }
    });
    console.log('Cupos guardados:', this.cuposOrganizaciones);
    console.log('Suma de cupos:', this.calculo_cupo);
  }

  guardarCuposAntesFiltrar() {
    this.inputCupo.forEach((inputRef, index) => {
      const idOrganizacion = this.filtroOrganizaciones[index]?.id_organizacion;
      if (idOrganizacion && inputRef.nativeElement.value) {
        this.cuposOrganizaciones[idOrganizacion] = inputRef.nativeElement.value;
      }
    });
  }

  restaurarCuposDespuesFiltrar() {
    this.filtroOrganizaciones.forEach((organizacion, index) => {
      const cupoInput = document.getElementById(`cupo_${organizacion.id_organizacion}`) as HTMLInputElement | null;
      if (cupoInput && this.cuposOrganizaciones[organizacion.id_organizacion]) {
        console.log("datos  ss :", this.cuposOrganizaciones[organizacion.id_organizacion]);
        console.log("datos  organi :", organizacion.id_organizacion);
        cupoInput.value = this.cuposOrganizaciones[organizacion.id_organizacion];
      }
    });
  }

  buscarOrganizaciones() {
    this.guardarCuposAntesFiltrar(); // Guardar los cupos antes de filtrar
    this.filtroOrganizaciones = this.servicios.buscarRecursivamente(
      this.organizaciones,
      this.nombreBusqueda
    );
    this.indiceADesactivar = null;
    this.restaurarCuposDespuesFiltrar(); // Restaurar los cupos después de filtrar
    console.log('oxox: ',this.cuposOrganizaciones)
  }


  listarAmbitos(id:number, year: number){
    this.servicios.listarAmbito(id.toString(), year.toString()).subscribe({
      next: (rs) => {
        this.resultado = rs.data.ambito;
        this.alternativa = rs.data.alternativa_cumplimiento;
        //console.log("Datos recibidos:", this.resultado);
      }
    });
  }




  interempresa(idAmbito: number, nom_ambito: string){
    this.modalService.open(this.content, {
      scrollable: true ,
      size: 'lg',
      backdrop: 'static',
      windowClass: 'modalClass',
      keyboard: false
    });
    this.mdl.cargando();
    this.servicios.listarOrganizacion(this.user.id_institucional.toString(), this.year!.toString(), idAmbito.toString(), '2', 0).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        if((rs.data).length > 0){
          this.organizaciones = rs.data;
          this.filtroOrganizaciones = [...this.organizaciones]; // Inicializa el array filtrado con todas las organizaciones
          this.idMetaRegional = '0';
          this.nomOrganizacion = 'Interempresa';
          this.id_ambito = idAmbito.toString();
          this.nom_ambito = nom_ambito;
          this.organizacionesSeleccionadas = [];
        }
        else{
          this.modalService.dismissAll(this.content)
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'El ambito seleccionado no tiene ninguna organización programada.';
          this.mdl.alerta();
        }
        //console.log("Datos recibidos organizacion: ", rs.data);
      }
    });



  }

  interempresa_2(idAmbito: number, nom_ambito: string){
    this.id_ambito = idAmbito.toString();
    this.nom_ambito = nom_ambito;
    this.isOrgSeleccion = true;
  }

  cargaChk(id: number, idOrganizacion: number, event: any) {
    this.estadoCheckboxes[idOrganizacion] = event.checked; // Actualizar el estado del checkbox
    const cupoInput = document.getElementById('cupo_' + idOrganizacion) as HTMLInputElement;
    if (event.checked) {
      if (!this.organizacionesSeleccionadas.includes(idOrganizacion)) {
        this.organizacionesSeleccionadas.push(idOrganizacion);
      }
      this.indiceADesactivar = id;
      if (cupoInput && this.cuposOrganizaciones[idOrganizacion]) {
        cupoInput.value = this.cuposOrganizaciones[idOrganizacion]; // Restaurar valor al marcar
      }
    } else {
      this.indiceADesactivar = null;
      const index = this.organizacionesSeleccionadas.indexOf(idOrganizacion);
      if (index > -1) {
        this.organizacionesSeleccionadas.splice(index, 1);
      }
      if (cupoInput) {
        cupoInput.value = ''; // Limpiar el input al desmarcar
      }
      delete this.cuposOrganizaciones[idOrganizacion]; // Eliminar el cupo si se desmarca
    }
    this.actualizarSumaCupos();
  }


  cierra(){
    this.indiceADesactivar = null;
    this.organizacionesSeleccionadas = []; // Limpia el array de organizaciones seleccionadas
    this.cuposOrganizaciones = {};
    this.estadoCheckboxes = {}; // Limpiar el estado de los checkboxes al cerrar
    this.modalService.dismissAll(this.content)
  }


  /*
  aceptar() {
    const buscador = (document.getElementById('buscar') as HTMLInputElement).value;
    if(buscador != ''){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'Por favor limpie el texto en el buscador de organizaciones';
      this.mdl.alerta();
    }
    else{
      if (this.organizacionesSeleccionadas.length == 0) {
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = 'Debes seleccionar al menos una(1) organización.';
        this.mdl.alerta();
      } else {
        // Guarda los valores de los cupos al aceptar
        this.organizacionesSeleccionadas.forEach(idOrganizacion => {
          const cupoInput = document.getElementById('cupo_' + idOrganizacion) as HTMLInputElement;
          if (cupoInput?.value) {
            this.cuposOrganizaciones[idOrganizacion] = cupoInput.value;
          } else {
            delete this.cuposOrganizaciones[idOrganizacion]; // Asegurar que no queden cupos vacíos para no seleccionados
          }
        });
        console.log('Empresas: ', this.organizacionesSeleccionadas, 'Cupos:', this.cuposOrganizaciones);
        this.isOrganizacion = true;
        this.modalService.dismissAll(this.content);
        // Aquí puedes enviar this.organizacionesSeleccionadas y this.cuposOrganizaciones a tu servicio
      }
    }

  }
  */

  volver(value: any) {
    console.log(value)
    this.cierra();
    if(!value.validador){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'El ambito seleccionado no tiene ninguna organización programada.';
      this.mdl.alerta();
    }
    if(value.final){
      this.titulo = '!EXITO¡';
      this.tipo_color = 'success';
      this.letra_color = 'light';
      this.mensaje = 'Petición realizada.';
      this.mdl.alerta();
    }
    this.indiceADesactivar = null;
    console.log('se guardo y trajo valor:  ',value.value);
    //this.isOrganizacion = value.value;
    this.isOrgSeleccion = value.value;
    this.listarAmbitos(this.user.id_institucional, this.year!);
  }


  antes(){
    this.subVolver.emit(false);
  }

}
